import { Route, Routes } from 'react-router-dom';
import Completed from '../Components/Completed';
import { InvestigationUI } from '@components/InvestigationUI';
const AppRoutes = () => {
	return (
		<Routes>
			<Route path="/" element={<InvestigationUI />} />
			<Route path={'/InvestigationEnded'} element={<Completed />} />
		</Routes>
	);
};

export default AppRoutes;
